export default function Testimonials() {
  const testimonials = [
    {
      name: 'John',
      location: 'Waitakere',
      text: 'I can highly recommend Ronnie Parkes work. The work he did on our older type house was at times complex and he completed it efficiently and in a timely fashion. We enjoyed having him here, as he was cheerful and always respectful regarding our preferences. His charges were transparent and reasonable and we would use his services again.',
      rating: 5,
    },
    {
      name: 'Colin',
      location: 'Remuera',
      text: 'Great job fixing door in other building applications',
      rating: 5,
    },
    {
      name: 'Alex',
      location: 'Mt Albert',
      text: 'Ronnie was excellent! Dedicated and meticulous from the very start, he planed every step, made sure I understood everything, then executed the plan flawlessly. I will definitely hire Ronnie for every bit of work going forward.',
      rating: 5,
    },
  ];

  return (
    <section id="reviews" className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            What Our Clients Say
          </h2>
          <div className="w-24 h-1 bg-orange-500 mx-auto mb-4 sm:mb-6"></div>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Don't just take our word for it – hear from our satisfied clients across Auckland.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white p-6 sm:p-8 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100"
            >
              <div className="flex items-center gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-orange-500 text-lg sm:text-xl"></i>
                ))}
              </div>
              <p className="text-sm sm:text-base text-gray-700 mb-5 sm:mb-6 leading-relaxed italic">
                "{testimonial.text}"
              </p>
              <div className="border-t border-gray-200 pt-4">
                <p className="font-semibold text-base sm:text-lg text-gray-900">{testimonial.name}</p>
                <p className="text-xs sm:text-sm text-gray-500">{testimonial.location}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="flex flex-wrap items-center justify-between gap-4 mt-10 sm:mt-12 px-2">
          <div className="inline-flex items-center gap-2 bg-orange-50 px-4 sm:px-6 py-3 sm:py-4 rounded-lg">
            <i className="ri-star-fill text-orange-500 text-xl sm:text-2xl"></i>
            <div className="text-left">
              <p className="text-xl sm:text-2xl font-bold text-gray-900">5.0</p>
              <p className="text-xs sm:text-sm text-gray-600">Average Rating</p>
            </div>
          </div>
          <span className="inline-flex items-center gap-2 text-orange-500 font-medium whitespace-nowrap">
            <span>More Reviews</span>
            <i className="ri-arrow-right-line"></i>
          </span>
        </div>
      </div>
    </section>
  );
}